import React, { useCallback, useMemo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { getPoiIconSvg, getPoiTypeColor, svgToDataUrl } from '../constants/poiIcons';
import styles from '../CreateRoute.module.scss';

/**
 * @param {{
 *   poi: object,
 *   isSelected: boolean,
 *   onSelect: (poi: object) => void,
 * }} props
 */
const PoiMarker = ({ poi, isSelected, onSelect }) => {
  const coord = poi.location?.coordinates;
  const type = (poi.type || 'marina').toLowerCase();
  const iconSrc = useMemo(() => svgToDataUrl(getPoiIconSvg(type)), [type]);
  const color = getPoiTypeColor(type);
  const label = poi.name || type;

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    onSelect(poi);
  }, [poi, onSelect]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onSelect(poi);
    }
  }, [poi, onSelect]);

  if (!coord || coord.length < 2) return null;

  return (
    <Marker longitude={coord[0]} latitude={coord[1]} anchor="center">
      <div
        className={`${styles.poiMarker} ${isSelected ? styles.poiMarkerSelected : ''}`}
        style={{ backgroundColor: color }}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={`${label} — ${type}`}
        title={label}
      >
        <img src={iconSrc} alt="" className={styles.poiMarkerIconImg} aria-hidden="true" />
      </div>
    </Marker>
  );
};

export default PoiMarker;
